import { createSlice } from "@reduxjs/toolkit";

export const uiExportMenuSlice = createSlice({
    name: "UI_export_menu",
    initialState: {
        exportFunctionActivated: false,
        exportedImages: [],
        showSaveUi: false,
        pdfIsGenerating: false,
    },
    reducers: {
        handleExportFunctionActivated: (state, action) => {
            state.exportFunctionActivated = action.payload;            
        },
        handleExportedImages: (state, action) => {
            state.exportedImages = action.payload;
        },   
        handleShowSaveUI: (state, action) => {
            state.showSaveUi = action.payload;
        },
        handlePDFGeneration: (state, action) => {
            state.pdfIsGenerating = action.payload;
        }
    }
});

export const {handleExportFunctionActivated,
            handleExportedImages, 
            handleShowSaveUI,    
            handlePDFGeneration                         
} = uiExportMenuSlice.actions;

export default uiExportMenuSlice.reducer;